<template>
    <el-dialog title="用户信息维护" :visible="visible" :show="show" width="45%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">

            <el-form-item label="新密码" class="input" prop="password">
                <el-input v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码" type="password" />
            </el-form-item>
            <el-form-item label="确认密码" class="input" prop="newPassword">
                <el-input v-model="ruleForm.newPassword" autocomplete="off" placeholder="请再次输入密码" type="password" />
            </el-form-item>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'userResetPass',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                this.ruleForm.id = this.rowData.id;
                this.ruleForm.account = this.rowData.account;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    password:'',
                    newPassword:'',
                },
                rules:{
                    password:[
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        {
                            validator: (rule, value, callback) => {
                                const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
                                if (regex.test(value)) {
                                    callback();
                                } else {
                                    callback(new Error('密码至少8位，必须包含英文字母和数字'));
                                }
                            },
                            trigger: 'blur'
                        }
                    ],
                    newPassword:[
                        { required: true, message: '请再次输入密码', trigger: 'blur' },
                        { validator: this.validatePassword, trigger: 'blur' }
                    ],
                },
            }
        },
        methods:{
            validatePassword(rule, value, callback) {
                if (value !== this.ruleForm.password) {
                    callback(new Error('两次输入的密码不一致'));
                } else {
                    callback();
                }
            },
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let params = {account:this.ruleForm.account,password:this.ruleForm.password,id:this.rowData.id};
                        this.$http({
                            url:  this.url+`users/resetPass`,
                            method: "post",
                            params:params
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "密码重置成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },

        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }
</style>